import SiteHeader from "./components/site-header";
import CookiesConsent from "./components/cookies-consent";
import ScrollInView from "./components/scroll-in-view";
import DeviceManager from "./utils/device-manager";


(function ($) {
	window.$ = $;

	$(function () {
		const $html = $("html");

		// Touch device detection
		if (DeviceManager.isHandheld()) {
			$html.addClass("touch");

			if (DeviceManager.isIos()) {
				$html.addClass("ios");
			}
		} else {
			$html.addClass("no-touch");
		}

		// IE detection
		if (DeviceManager.isIe11()) {
			$html.addClass("ie11");
		} else if (DeviceManager.isEdge()) {
			$html.addClass("edge");
		}

		// General components
		const siteHeader = new SiteHeader($(".site-header"), 20);
		
		// Cookie consent
		if (typeof tarteaucitron !== "undefined" && tarteaucitron) {
			// Tarteaucitron cookie settings
			let tarteaucitronLang = "fr";

			const cookiesConsent = new CookiesConsent(tarteaucitronLang);
		}

		// Scroll in view component
		const $scrollInViewElements = $(".scroll-in-view");
		if ($scrollInViewElements.length) {
			$scrollInViewElements.imagesLoaded(function () {
				const scrollInView = new ScrollInView($scrollInViewElements);
			});
		}

		// SVG animation - lenght auto calculation
		const paths = document.querySelectorAll(".double-text-image-section__svg svg path, .text-image-section .background-svg svg path");
		[].forEach.call(paths, function(path) {
			const length = path.getTotalLength();
			path.style.strokeDasharray = length + ' ' + length;
			path.style.strokeDashoffset = length;

		});

		// Evénement au scroll pour lancer l'animation des SVG (#line)
		if ($( 'body' )) {
			$(window).on('scroll', function (e) {
                if($('.double-text-image-section').length > 0) {
                    if($(window).scrollTop() >= $('.double-text-image-section').offset().top - 500){
                        $('.double-text-image-section__svg svg path').addClass('active');
                    }
                }
                if($('.text-image-section').length > 0) {
                    if($(window).scrollTop() >= $('.text-image-section').offset().top - 500){
                        $('.background-svg svg path').addClass('active');
                    }
                }
				/* if($(window).scrollTop() >= $('.homepage-header').offset().top - 100){
					$('.homepage-header__svg svg path').addClass('active');
				} */
			});
			// $('.homepage-header__svg svg path').addClass('active');
		}
	});
})(jQuery);
